import React, { useCallback, useEffect, useState } from "react";
import ledger from "../../../images/Icons/ledger.png";
import { useParams } from "react-router";
import axios from "axios";
import config from "../../../config";
import NumberFormatter from "../../../Component/NumberFormatter";
import useLogout from "../../Auth/useLogout";
import NoData from "../../../Component/NoData";
import Dataloader from "../../../Component/Dataloader";

export default function OrderLedger() {
  const params = useParams();
  const logout = useLogout();
  const [ledgerData, setLedgerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.apiUrl}/customer/order-ledger/${params.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );
      setLedgerData(response.data.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  }, [params.id, logout]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                {ledgerData.length > 0 ? (
                  <>
                    <div className="row-hd-txt">
                      <div className="row-hd-txt-left">
                        <img src={ledger} alt="icon" />
                        <h5>Order Ledger</h5>
                      </div>
                      {/* <div className="ledger-txt-right">
                        <button className="print-btn" title="print">
                          <i className="bi bi-printer"></i>Print
                        </button>
                      </div> */}
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="ledger-table table-responsive">
                          <table className="table table-bordered m-0">
                            <thead>
                              <tr>
                                <th scope="col">S No.</th>
                                <th scope="col">Date</th>
                                <th scope="col">Particulars</th>
                                <th scope="col">TXN Id</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Type</th>
                                <th scope="col">Payment Mode</th>
                              </tr>
                            </thead>
                            <tbody>
                              {ledgerData.map((data, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{data.created_at_date}</td>
                                    <td>{data.description}</td>
                                    <td>{data.transaction_id}</td>
                                    <td>
                                      Rs{" "}
                                      <NumberFormatter number={data.amount} />
                                    </td>
                                    <td className="text-capital">
                                      {data.type}
                                    </td>
                                    <td>
                                      {data.payment_mode
                                        ? data.payment_mode
                                        : "-"}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <NoData />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
